var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-mask" }, [
    _c("div", { staticClass: "modal-wrapper" }, [
      _c("div", { staticClass: "modal_size md_size" }, [
        _c(
          "a",
          {
            staticClass: "ui_close",
            attrs: { href: "javascript:", type: "button" },
            on: { click: _vm.btnClose }
          },
          [_c("span", { staticClass: "sr_only" }, [_vm._v("popup close")])]
        ),
        _vm._v(" "),
        _c("dl", { staticClass: "modal_content" }, [
          _c("dt", { staticClass: "ellipsis" }, [
            _c("i", [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.ETC.077")))])
          ]),
          _vm._v(" "),
          _c("dd", [
            _c("dl", { staticClass: "srcModel_wrap" }, [
              _c("dt", { staticClass: "tree_box" }, [
                _c("article", { staticClass: "tree_wrap" }, [
                  _c(
                    "ul",
                    { staticClass: "tree_list" },
                    _vm._l(_vm.getRefineMenus, function(menu1, idx) {
                      return _c("li", { key: "tree" + menu1.menuId }, [
                        menu1.subMenu.length > 0
                          ? _c(
                              "a",
                              {
                                staticClass: "ico_tree",
                                attrs: { href: "javascript:" },
                                on: {
                                  click: function($event) {
                                    return _vm.treeClick($event, menu1.menuId)
                                  }
                                }
                              },
                              [_c("span", { staticClass: "sr_only" })]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            on: {
                              click: function($event) {
                                return _vm.menuClick(
                                  $event,
                                  menu1,
                                  menu1.subMenu
                                )
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                                            " +
                                _vm._s(
                                  menu1.menuNm +
                                    (menu1.pcOnlyYn === "Y" ? " (PC Only)" : "")
                                ) +
                                "\n                                        "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        menu1.subMenu
                          ? _c(
                              "ul",
                              { staticClass: "tree_sub_list" },
                              _vm._l(menu1.subMenu, function(menu2) {
                                return _c(
                                  "li",
                                  { key: "tree" + menu2.menuId },
                                  [
                                    menu2.subMenu.length > 0
                                      ? _c(
                                          "a",
                                          {
                                            staticClass: "ico_tree",
                                            attrs: { href: "javascript:" },
                                            on: {
                                              click: function($event) {
                                                return _vm.treeClick(
                                                  $event,
                                                  menu2.menuId
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("span", {
                                              staticClass: "sr_only"
                                            })
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        on: {
                                          click: function($event) {
                                            return _vm.menuClick(
                                              $event,
                                              menu2,
                                              menu2.subMenu
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                                    " +
                                            _vm._s(
                                              menu2.menuNm +
                                                (menu1.pcOnlyYn === "Y" ||
                                                menu2.pcOnlyYn === "Y"
                                                  ? " (PC Only)"
                                                  : "")
                                            ) +
                                            "\n                                                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    menu2.subMenu
                                      ? _c(
                                          "ul",
                                          { staticClass: "tree_sub_list" },
                                          _vm._l(menu2.subMenu, function(
                                            menu3
                                          ) {
                                            return _c(
                                              "li",
                                              { key: "tree" + menu3.menuId },
                                              [
                                                menu3.subMenu.length > 0
                                                  ? _c(
                                                      "a",
                                                      {
                                                        staticClass: "ico_tree",
                                                        attrs: {
                                                          href: "javascript:"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.treeClick(
                                                              $event,
                                                              menu3.menuId
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("span", {
                                                          staticClass: "sr_only"
                                                        })
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.menuClick(
                                                          $event,
                                                          menu3,
                                                          menu3.subMenu
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                                            " +
                                                        _vm._s(
                                                          menu3.menuNm +
                                                            (menu1.pcOnlyYn ===
                                                              "Y" ||
                                                            menu2.pcOnlyYn ===
                                                              "Y" ||
                                                            menu3.pcOnlyYn ===
                                                              "Y"
                                                              ? " (PC Only)"
                                                              : "")
                                                        ) +
                                                        "\n                                                        "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          }),
                                          0
                                        )
                                      : _vm._e()
                                  ]
                                )
                              }),
                              0
                            )
                          : _vm._e()
                      ])
                    }),
                    0
                  )
                ])
              ]),
              _vm._v(" "),
              _c("dd", { staticClass: "btn" }, [
                _c("span", [
                  _c("a", {
                    staticClass: "ico_arrow_next box",
                    attrs: {
                      href: "javascript:",
                      title: _vm.$t("BUTTON.GLOBAL.ADD")
                    },
                    on: { click: _vm.btnAdd }
                  }),
                  _vm._v(" "),
                  _vm.selMyMenuList.length > 0
                    ? _c("a", {
                        staticClass: "ico_arrow_prev box",
                        attrs: {
                          href: "javascript:",
                          title: _vm.$t("BUTTON.GLOBAL.REMOVE")
                        },
                        on: { click: _vm.btnRemove }
                      })
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("dd", { staticClass: "select_menu" }, [
                _c("div", { staticClass: "txt" }, [
                  _vm._v("Selected my Menus")
                ]),
                _vm._v(" "),
                _vm.selMyMenuList.length > 0
                  ? _c(
                      "ul",
                      { staticClass: "select_list" },
                      _vm._l(_vm.selMyMenuList, function(selMenu) {
                        return _c(
                          "li",
                          {
                            class:
                              selMenu.MENU_ID === _vm.selMyMenuId
                                ? "active"
                                : "",
                            attrs: { "data-id": selMenu.MENU_ID },
                            on: {
                              click: function($event) {
                                return _vm.clickSelMyMenu(selMenu.MENU_ID)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                                    " +
                                _vm._s(selMenu.MENU_NM) +
                                "\n                                "
                            )
                          ]
                        )
                      }),
                      0
                    )
                  : _c("ul", { staticClass: "select_list" }, [
                      _vm._v(
                        "\n                                " +
                          _vm._s(_vm.$t("MESSAGE.GLOBAL.NO.DATA")) +
                          "\n                            "
                      )
                    ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("dd", { staticClass: "scroll_btm" }, [
            _c("div", { staticClass: "btn_modal_wrap topLine" }, [
              _c("div", { staticClass: "btn_right" }, [
                _c(
                  "a",
                  {
                    staticClass: "btn_white",
                    attrs: { href: "javascript:" },
                    on: { click: _vm.btnClose }
                  },
                  [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.CANCEL")))]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "btn_blue",
                    attrs: { href: "javascript:" },
                    on: { click: _vm.btnApply }
                  },
                  [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.APPLY")))]
                )
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-137bbba8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-137bbba8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/common/MyMenuConfigPopup.vue
// module id = +6je
// module chunks = 0